/** Mirrors backend — sales point POS view: restaurant vs simple shop billing */

export const WORK_CATEGORIES = {
  RESTAURANT: "restaurant",
  SIMPLE: "simple",
} as const;

export type WorkCategory =
  (typeof WORK_CATEGORIES)[keyof typeof WORK_CATEGORIES];

export const WORK_CATEGORY_VALUES = Object.values(WORK_CATEGORIES);

export const WORK_CATEGORY_OPTIONS: { value: WorkCategory; label: string }[] = [
  { value: "restaurant", label: "Restaurant (table booking)" },
  {
    value: "simple",
    label: "Simple (grocery, medical, shop, wholesale)",
  },
];

export const WORK_CATEGORY_LABELS: Record<WorkCategory, string> = {
  restaurant: "Restaurant (table booking)",
  simple: "Simple (grocery, medical, shop, wholesale)",
};

export function normalizeWorkCategory(value?: string | null): WorkCategory {
  const v = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (!v || v === "restaurant") return WORK_CATEGORIES.RESTAURANT;
  return WORK_CATEGORIES.SIMPLE;
}

export function workCategoryLabel(value?: string | null): string {
  if (value == null || String(value).trim() === "") return "—";
  return WORK_CATEGORY_LABELS[normalizeWorkCategory(value)];
}

/** Dedupe + map legacy tags (grocery, medical, …) → restaurant | simple */
export function uniqueNormalizedWorkCategories(
  values?: Array<string | null | undefined> | null
): WorkCategory[] {
  if (!Array.isArray(values) || !values.length) return [];
  const seen = new Set<WorkCategory>();
  const out: WorkCategory[] = [];
  for (const value of values) {
    const next = normalizeWorkCategory(value);
    if (seen.has(next)) continue;
    seen.add(next);
    out.push(next);
  }
  return out;
}
